import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { FlowClient, IntegrationEventMetadataModel } from '../../../api/api';
import useApiClient from '../../../common/hooks/useApiClient';

export default function useApiIntegrationEvents(contextId: string | undefined): UseQueryResult<IntegrationEventMetadataModel[], Error> {
	const client = useApiClient(FlowClient);
	const integrationEvents = useQuery({
		queryKey: ['flow', 'integrationEvents', contextId],
		queryFn: () => client.getIntegrationEvents(contextId),
	});
	return integrationEvents;
}
